// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: whitesmoke;

}

.search-button {
    background-color: #286090;
    color: white;
    height: 35px;
    padding: 3px 15px;
    border-radius: 5px;
    cursor: pointer;
}

.scroll {
    color: red;
    font-size: 18px;
    font-weight: 30px;
}

.doa-container {
    border: 1px solid #0b2d71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}

.header {
    background-color: #286090;
    text-align: left;
    margin-left: 20px;
    margin-right: 20px;
    height: 35px;

}

.header1 {
    padding-top: 5px;
    padding-left: 10px;
    color: black;
}

.catTitle {
    color: #286090;
    margin-left: 30px;

}

.boldtext {
    font-weight: bold;
    padding-left: 70px;
    color: black;
    margin-top: 15px;
    padding-bottom: 15px;
}

.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width: 100%;
}

.doa-container1 {
    border: 2px solid #0b2d71;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
}

.one {
    font-size: 20px;

}

.doatypename {
    float: left;
    margin-left: 50px;
}

.employeedetails {
    float: right;
    margin-right: 200px;
}

.container2 {
    background-color: #F1F1F1;
    border: solid 1px #d4d4d4;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 50px;
}

.scroll {
    color: red;
    font-size: 18px;
    font-weight: 30px;
}

.doa-container {
    border: 1px solid #0b2d71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}

.header {
    background-color: #5385b0;
    text-align: left;
    margin-left: 20px;
    margin-right: 20px;
    height: 35px;

}

.header1 {
    padding-top: 5px;
    padding-left: 10px;
    color: black;
}

.catTitle {
    color: rgba(0, 48, 153, 1);
    margin-left: 30px;
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

.boldtext {
    font-weight: bold;
    padding-left: 70px;
    color: black;
    margin-top: 15px;
    padding-bottom: 15px;
}

.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width: 100%;
}

.doatype {
    color: black;
    padding-left: 20%;

}

.doatype2 {

    color: black;
    padding-left: 55%;


}

.one {
    font-size: 20px;

}

.container1 {
    height: 30px;
    width: 100%;
    background-color: #5385b0;
}

.doatypename {
    margin-left: 50px;
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

.radio-label {
    margin-right: 15px;
    margin-left: 5px;
}

.emailinput {
    margin-left: 117px;
    height: 35px;
    border-radius: 5px;
    width: 150px;
}

.dateinput {
    margin-left: 100px;
    height: 35px;
    border-radius: 5px;
    width: 150px;
}

.menu {
    background-color: #5385b0;
}

.option {
    background-color: white;
    color: #000;
    font-weight: bolder;
}

.viewAction {
    float: left;
    margin-right: 300px;
}

/* Modal styles */
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
}

.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


/* OK button styles */
#closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
}

#closeSuccessModal:hover {
    background-color: #0056b3;
}

.upload-input-file {
    margin: 10px 10px;
    font-size: 20px;
    font-family: Roboto, sans-serif;
    background-color: #5385b0;
    padding: 10px;
    color: white;
    border-radius: 10px;
    border: none;
    cursor: pointer;

}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.fileAttachments {
    float: left;
    padding-left: 450px;
}

.title {
    font-family: "GothamBold", Arial, sans-serif;
}

.content {
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.actions {
    display: flex;
    justify-content: center;
}

.actions button {
    margin-right: 50px;
    margin-top: 30px;
    margin-bottom: 30px;
}

.form-control-sm.menu:disabled {
    color: #000;
}

select:disabled {
    color: #000;
    border-color: rgba(118, 118, 118, 0.3);
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/admin/permanentdoaadmin/permanentdoaadmin.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;;AAEhC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;;;AAGrB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;AAChF;;;AAGA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA,w5UAAw5U","sourcesContent":["body {\n    background-color: whitesmoke;\n\n}\n\n.search-button {\n    background-color: #286090;\n    color: white;\n    height: 35px;\n    padding: 3px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.scroll {\n    color: red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n\n.doa-container {\n    border: 1px solid #0b2d71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.header {\n    background-color: #286090;\n    text-align: left;\n    margin-left: 20px;\n    margin-right: 20px;\n    height: 35px;\n\n}\n\n.header1 {\n    padding-top: 5px;\n    padding-left: 10px;\n    color: black;\n}\n\n.catTitle {\n    color: #286090;\n    margin-left: 30px;\n\n}\n\n.boldtext {\n    font-weight: bold;\n    padding-left: 70px;\n    color: black;\n    margin-top: 15px;\n    padding-bottom: 15px;\n}\n\n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width: 100%;\n}\n\n.doa-container1 {\n    border: 2px solid #0b2d71;\n    width: 100%;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.one {\n    font-size: 20px;\n\n}\n\n.doatypename {\n    float: left;\n    margin-left: 50px;\n}\n\n.employeedetails {\n    float: right;\n    margin-right: 200px;\n}\n\n.container2 {\n    background-color: #F1F1F1;\n    border: solid 1px #d4d4d4;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    padding: 50px;\n}\n\n.scroll {\n    color: red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n\n.doa-container {\n    border: 1px solid #0b2d71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.header {\n    background-color: #5385b0;\n    text-align: left;\n    margin-left: 20px;\n    margin-right: 20px;\n    height: 35px;\n\n}\n\n.header1 {\n    padding-top: 5px;\n    padding-left: 10px;\n    color: black;\n}\n\n.catTitle {\n    color: rgba(0, 48, 153, 1);\n    margin-left: 30px;\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.boldtext {\n    font-weight: bold;\n    padding-left: 70px;\n    color: black;\n    margin-top: 15px;\n    padding-bottom: 15px;\n}\n\n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width: 100%;\n}\n\n.doatype {\n    color: black;\n    padding-left: 20%;\n\n}\n\n.doatype2 {\n\n    color: black;\n    padding-left: 55%;\n\n\n}\n\n.one {\n    font-size: 20px;\n\n}\n\n.container1 {\n    height: 30px;\n    width: 100%;\n    background-color: #5385b0;\n}\n\n.doatypename {\n    margin-left: 50px;\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.radio-label {\n    margin-right: 15px;\n    margin-left: 5px;\n}\n\n.emailinput {\n    margin-left: 117px;\n    height: 35px;\n    border-radius: 5px;\n    width: 150px;\n}\n\n.dateinput {\n    margin-left: 100px;\n    height: 35px;\n    border-radius: 5px;\n    width: 150px;\n}\n\n.menu {\n    background-color: #5385b0;\n}\n\n.option {\n    background-color: white;\n    color: #000;\n    font-weight: bolder;\n}\n\n.viewAction {\n    float: left;\n    margin-right: 300px;\n}\n\n/* Modal styles */\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n}\n\n.modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 500px;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n\n/* OK button styles */\n#closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n}\n\n#closeSuccessModal:hover {\n    background-color: #0056b3;\n}\n\n.upload-input-file {\n    margin: 10px 10px;\n    font-size: 20px;\n    font-family: Roboto, sans-serif;\n    background-color: #5385b0;\n    padding: 10px;\n    color: white;\n    border-radius: 10px;\n    border: none;\n    cursor: pointer;\n\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.fileAttachments {\n    float: left;\n    padding-left: 450px;\n}\n\n.title {\n    font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.content {\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.actions {\n    display: flex;\n    justify-content: center;\n}\n\n.actions button {\n    margin-right: 50px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.form-control-sm.menu:disabled {\n    color: #000;\n}\n\nselect:disabled {\n    color: #000;\n    border-color: rgba(118, 118, 118, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
